import React from 'react';
import {withRouter} from "react-router-dom"
import { TitleXl,  Row,  Col4, Col8} from "components/elements";
import { AboutUsTopSectionContainer, TitleXlContainer, FlexContainer} from './elements';
import ViewAllAnchor from "components/ViewAllAnchor";
import RichText from 'components/RichText';

function AboutUsTopWhiteSection({content, width}) {

return(
        <AboutUsTopSectionContainer>
            <TitleXlContainer width={width}>
                <TitleXl fontWeight="900">{content.title}</TitleXl>
            </TitleXlContainer>
            <FlexContainer>
            <Row>
                <Col8>           
                    <img src={content.columnMedia} alt={""} />           
                </Col8>
                <Col4>        
                    <RichText body={content?.columnCopy && content?.columnCopy} />
                    <ViewAllAnchor title={content.ctaCopy} href={content.ctaPdfFile} target="_blank" borderColor="#000" borderColorHover="#fff" titleColor="#000" hoverBackground="#000" width="300px" height="44px" svgColor="#000" />
                </Col4>
            </Row>
            </FlexContainer>
        </AboutUsTopSectionContainer>
    )
}

export default withRouter(AboutUsTopWhiteSection);
